import { AlertTriangle, ArrowUp, Minus, ArrowDown } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

interface PriorityBadgeProps {
  priority: string | null;
}

const priorityConfig: Record<string, { label: string; className: string; icon: React.ReactNode }> = {
  urgent: {
    label: 'URGENT',
    className: 'bg-urgent/10 text-urgent border-urgent/20',
    icon: <AlertTriangle className="size-3" />,
  },
  high: {
    label: 'HIGH',
    className: 'bg-high/10 text-high border-high/20',
    icon: <ArrowUp className="size-3" />,
  },
  medium: {
    label: 'MEDIUM',
    className: 'bg-medium/10 text-medium border-medium/20',
    icon: <Minus className="size-3" />,
  },
  low: {
    label: 'LOW',
    className: 'bg-low/10 text-low border-low/20',
    icon: <ArrowDown className="size-3" />,
  },
};

export function PriorityBadge({ priority }: PriorityBadgeProps) {
  if (!priority) return null;

  const config = priorityConfig[priority.toLowerCase()] || {
    label: priority.toUpperCase(),
    className: '',
    icon: null,
  };

  return (
    <Badge variant="outline" className={config.className}>
      {config.icon}
      {config.label}
    </Badge>
  );
}
